import { createFileRoute } from "@tanstack/react-router";
import PartsManufacturers from "@/pages/PartsManufacturers";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/manufacturers")({
  head: () => pageHead({ title: 'Parts Brands', description: 'Shop RV parts by brand at Rex & Sons RVs.', path: '/parts-catalog/manufacturers' }),
  component: PartsManufacturers,
});
